import { render, staticRenderFns } from "./report-mensalidadespagas.vue?vue&type=template&id=144f20fe&scoped=true&"
import script from "./report-mensalidadespagas.vue?vue&type=script&lang=js&"
export * from "./report-mensalidadespagas.vue?vue&type=script&lang=js&"
import style0 from "./report-mensalidadespagas.vue?vue&type=style&index=0&id=144f20fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f20fe",
  null
  
)

export default component.exports